import React from 'react';

import { Link } from 'gatsby';

import AccordionMobile from '@/components/Elements/AccordionMobile/AccordionMobile';

import { IFooterItem } from '@/types/types';

import './FooterMobile.scss';

interface Props {
  services: IFooterItem;
  industries: IFooterItem;
  technologies: IFooterItem;
}

const FooterMobile = ({ services, industries, technologies }: Props) => (
  <AccordionMobile
    customClass="Footer_mobile"
    indexActive={null}
    tabItems={[
      { id: services.id, title: services.title },
      { id: industries.id, title: industries.title },
      { id: technologies.id, title: technologies.title },
    ]}
    customItems={[
      {
        id: services.id,
        content: (
          <ul className="Footer_mobile-list">
            {services.items.map((item) => (
              <li key={item.id} className="Footer_mobile-list-item">
                <Link
                  to={item.landing?.path || '/'}
                  aria-label={item.title}
                  className="body-3 Footer_mobile-list-item-link"
                >
                  {item.title}
                </Link>
              </li>
            ))}
          </ul>
        ),
      },
      {
        id: services.id,
        content: (
          <div className="Footer_mobile-industries-technologies">
            {industries.items.map((item) => (
              <Link
                key={item.id}
                to={item.landing?.path || '/'}
                aria-label={item.title}
                className="Footer_mobile-industries-technologies-link medium"
              >
                <p className="body-3 Footer_mobile-industries-technologies-link-item">{item.title}</p>
              </Link>
            ))}
          </div>
        ),
      },
      {
        id: services.id,
        content: (
          <div className="Footer_mobile-industries-technologies">
            {technologies.items.map((item) => (
              <Link
                key={item.id}
                to={item.landing?.path || '/'}
                aria-label={item.title}
                className="Footer_mobile-industries-technologies-link medium"
              >
                <p className="body-3 Footer_mobile-industries-technologies-link-item">{item.title}</p>
              </Link>
            ))}
          </div>
        ),
      },
    ]}
  />
);

export default FooterMobile;
